export const FeatureFlag = {
  UpdateEnabled: false,
  DeleteMessageHistoryTalk: false,
  ToggleChatSearch: false,
  Docs: true,
  Audio: true,
  Translation: true,
  Analytics: true,
};
